import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login/Login';
import UserDashboard from './components/User/UserDashboard';
import AdminDashboard from './components/Admin/AdminDashboard';
import TicketChat from './components/Chat/TicketChat';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

function PrivateRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }
  
  if (adminOnly && !user.is_admin) {
    return <Navigate to="/dashboard" />;
  }
  
  return children;
}

function HomeRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (user.is_admin) {
    return <Navigate to="/admin" />;
  }

  return <Navigate to="/dashboard" />;
}

function App() {
  return (
    <AuthProvider>
      <Router basename="/">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route 
            path="/dashboard" 
            element={
              <PrivateRoute>
                <UserDashboard />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/admin" 
            element={
              <PrivateRoute adminOnly={true}>
                <AdminDashboard />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/ticket/:ticketId" 
            element={
              <PrivateRoute>
                <TicketChat />
              </PrivateRoute>
            } 
          />
          <Route path="/" element={<HomeRoute />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
